import { useCallback, useEffect, useRef, useState } from 'react';

export default function useInitialViewportVisibility(items, getId, options = {}) {
    const { enabled = true, resetKey = 'default' } = options;
    const [visibleIds, setVisibleIds] = useState(new Set());
    const elementsRef = useRef({});
    const capturedRef = useRef(false);

    useEffect(() => {
        capturedRef.current = false;
        setVisibleIds(new Set());
        elementsRef.current = {};
    }, [resetKey]);

    const setItemRef = useCallback((id) => {
        return (el) => {
            const key = String(id);
            if (el) {
                elementsRef.current[key] = el;
            } else {
                delete elementsRef.current[key];
            }
        };
    }, []);

    useEffect(() => {
        if (!enabled || capturedRef.current || !items || items.length === 0) return;

        const frame = requestAnimationFrame(() => {
            const nextVisibleIds = new Set();

            items.forEach((item) => {
                const key = String(getId(item));
                const el = elementsRef.current[key];
                if (!el) return;

                const rect = el.getBoundingClientRect();
                const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
                if (isVisible) nextVisibleIds.add(key);
            });

            setVisibleIds(nextVisibleIds);
            capturedRef.current = true;
        });

        return () => cancelAnimationFrame(frame);
    }, [enabled, getId, items]);

    const isInitiallyVisible = useCallback((id) => visibleIds.has(String(id)), [visibleIds]);

    return { setItemRef, isInitiallyVisible };
}
